import React, { Component } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import saveCareerPath from '../../assets/images/illustration_save-career-path.svg';

import { copyToClipBoard, createColorStyles, createMapPathUrl, updateMapPathUrl } from '../common/utilities';
import * as ReactDOM from 'react-dom';

export class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: null,
        }

        this.pathUrlOnClick = this.pathUrlOnClick.bind(this);
    }

    componentDidMount() {
        const { isMixpanel } = this.props;

        this.setState({
            width: document.body.clientWidth + 'px'
        })

        window.addEventListener('resize', () => {
            this.setState({
                width: document.body.clientWidth + 'px'
            })
        });

        $(document).on('click', '.path-courses li a', function() {
            const el = $(this);

            const jobTitle = el.closest('.path').find('.job-title').text() || 'N/A';

            if (isMixpanel) {
                window.mixpanel.track('Content Link Click', {
                    'Content Url': el.attr('href'),
                    'Job Title': jobTitle,
                });
            }
        });
    }

    pathUrlOnMouseOut(e) {
        const el = e.currentTarget;

        el.querySelector('.hover-message').classList.remove('show');
    }

    pathUrlOnMouseOver(e) {
        const el = e.currentTarget;

        if (!el.classList.contains('no-hover')) {
            el.querySelector('.hover-message').classList.add('show');

            setTimeout(() => {
                el.querySelector('.hover-message').classList.remove('show');
            }, 2000);
        }
    }

    prepareUrl() {
        const { getTracedJobs } = this.props;

        return createMapPathUrl(getTracedJobs());
    }

    setUrl(url) {
        updateMapPathUrl(url);
        copyToClipBoard(url);
    }

    pathUrlOnClick(e) {
        const { isMixpanel } = this.props;

        e.preventDefault();

        const el = e.currentTarget;

        const url = this.prepareUrl();

        this.setUrl(url);

        el.classList.add('no-hover');

        const messageContainer = $('.message');

        messageContainer.fadeIn('fast');

        setTimeout(() => {
            messageContainer.fadeOut('fast', () => {
                el.classList.remove('no-hover');
            });
        }, 1000);

        const jobTitle = $('.path').find('.path-job:last-of-type h4').text() || 'N/A';

        if (isMixpanel) {
            window.mixpanel.track('Copy URL Link Click', {
                'Copied Url': url,
                'Job Title': jobTitle,
            });
        }
    }

    render() {
        const { getTracedJobs, jobs, categories, direction, levels, isCurated, isShowCollegeDegree, isShowSalary } = this.props;
        const { width } = this.state;

        if (!jobs.length) {
            return null;
        }

        const tracedJobs = getTracedJobs();

        let mainJob = null;

        if (tracedJobs.length) {
            mainJob = jobs.filter(job => job.id === tracedJobs[tracedJobs.length - 1])

            if (mainJob.length) {
                mainJob = mainJob[0]
            }
        }

        const directionJobs = direction == 'upward' ? [...tracedJobs].reverse() : tracedJobs;

        return (
            <>
                <div
                    className={classNames('share-map', {
                        'is-active': !isCurated(),
                    })}
                    style={{
                        width,
                        position: 'relative',
                        left: '50%',
                        transform: 'translateX(-50%)',
                    }}
                >
                    <div className="grid-container d-md-flex align-items-md-center">
                        <div className="share-map__title">
                            {
                                tracedJobs.length ? 'Is this Career Path for you?' :  'Build a Career Path with the map, then'
                            }
                        </div>
                        <a
                            href="#share"
                            className="share-map__button js-modal"
                        >
                            {
                                tracedJobs.length ? 'Save it & Share it here' :  'Save it & Share it!'
                            }
                        </a>
                    </div>

                </div>

                {
                    ReactDOM.createPortal(
                        <div className="modal-outer-wrapper modal-base modal-share" id="share">
                            <div className="modal-inner-wrapper d-table">
                                <div className="d-table-cell">
                                    <div className="modal">
                                        <div className="container">
                                            <button className="modal-close js-modal-close"><span className="show-for-sr">Close modal</span>
                                            </button>
                                            <h2 className="modal-base__title">Bookmark this page to save your career path. You can also
                                                copy/paste the link below to share it via email or social media:​</h2>
                                            <div className="modal-share__link">
                                                <a href="#">{this.prepareUrl()}</a>
                                            </div>
                                            <div className="modal-share__copy">
                                                <a
                                                    href="#"
                                                    className="path-url"
                                                    onClick={this.pathUrlOnClick}
                                                    onMouseOver={this.pathUrlOnMouseOver}
                                                    onMouseOut={this.pathUrlOnMouseOut}
                                                >
                                                    <span className="path-url__title">Copy</span>
                                                    <span className="message">Link Copied</span>
                                                    <span className="hover-message"><p>Copy URL link</p><p>Save it to have a quick access to this Learning Path</p></span>
                                                </a>
                                            </div>

                                            <p>Feel free to close this pop-up box and create a new career map.​</p>

                                            <div className="modal-share__congrats d-md-flex align-items-md-center justify-content-md-between">
                                                <div className="modal-share__message">Congrats on taking charge of your career!​</div>
                                                <div className="modal-share__illustration">
                                                    <img src={saveCareerPath} alt="" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>,
                        document.querySelector('body')
                    )
                }

                <footer
                    className={classNames('map-footer bg-smoke', {
                        'upward': direction == 'upward',
                    })}
                    style={{
                        width,
                        position: 'relative',
                        left: '50%',
                        transform: 'translateX(-50%)',
                    }}
                    id="learning-path"
                >
                    <div className="grid-container">
                        <div className="path">
                            <h3 className="path-title">Your Career Path:</h3>

                            {
                                !mainJob && (<p className="start">Start by selecting one or more jobs on the career map.</p>)
                            }

                            {
                                directionJobs
                                    .map((jobId, tracedJobIndex) => {
                                        let job = jobs.filter(job => job.id === jobId);

                                        if (job.length) {
                                            job = job[0];

                                            let category = categories.filter(category => category.id === job.job_category.id);
                                            category = category.length ? category[0] : categories[0];

                                            let levelIndex  = levels.findIndex(level => level.id === job.job_level.id);
                                            levelIndex = levelIndex !== -1 ? levelIndex : 0;

                                            const classes = `path-job level-${levelIndex + 1}${levelIndex + 1 === levels.length ? ' level-last' : ''}${levelIndex + 1 === 1 ? ' level-first' : ''}`;

                                            if( direction == 'upward' ) {

                                                return (
                                                    <>
    
                                                        <div
                                                            className={classes}
                                                            style={createColorStyles(category)}
                                                        >
                                                            <div className="path-job__header">
                                                                <div className="dot" />
                                                                <h4>{job.name}</h4>
                                                                <span className="level">{job.job_level.name}</span>
                                                                { isShowCollegeDegree && job.requires_college_degree && <div className="special diamond" />}
                                                            </div>
    
                                                            {
                                                                isShowSalary &&
                                                                job.compensation &&
                                                                (job.compensation.salary && job.compensation.salary.low_end && job.compensation.salary.high_end) &&
                                                                (
                                                                    <div className="path-job__price">{job.compensation.salary.low_end} - {job.compensation.salary.high_end}<i> / year</i></div>
                                                                )
                                                            }
    
    
                                                            {
                                                                job.indeed_url && (
                                                                    <a href={job.indeed_url} className="path-job__button" target="_blank">Search Jobs</a>
                                                                )
                                                            }
                                                        </div>

                                                        {
                                                            job.job_suggested_content ? (
                                                                <ul
                                                                    className="path-courses"
                                                                    key={tracedJobIndex}
                                                                >
                                                                    {
                                                                        job.job_suggested_content.map((content, contentIndex) => <li key={contentIndex}><a href={content.url} target="_blank">{content.name}</a></li>)
                                                                    }
                                                                </ul>
                                                            ) : null
                                                        }

                                                    </>
                                                )

                                            } else {

                                                return (
                                                    <>
                                                        {
                                                            job.job_suggested_content ? (
                                                                <ul
                                                                    className="path-courses"
                                                                    key={tracedJobIndex}
                                                                >
                                                                    {
                                                                        job.job_suggested_content.map((content, contentIndex) => <li key={contentIndex}><a href={content.url} target="_blank">{content.name}</a></li>)
                                                                    }
                                                                </ul>
                                                            ) : null
                                                        }

                                                        <div
                                                            className={classes}
                                                            style={createColorStyles(category)}
                                                        >
                                                            <div className="path-job__header">
                                                                <div className="dot" />
                                                                <h4>{job.name}</h4>
                                                                <span className="level">{job.job_level.name}</span>
                                                                { isShowCollegeDegree && job.requires_college_degree && <div className="special diamond" />}
                                                            </div>

                                                            {
                                                                isShowSalary &&
                                                                job.compensation &&
                                                                (job.compensation.salary && job.compensation.salary.low_end && job.compensation.salary.high_end) &&
                                                                (
                                                                    <div className="path-job__price">{job.compensation.salary.low_end} - {job.compensation.salary.high_end}<i> / year</i></div>
                                                                )
                                                            }


                                                            {
                                                                job.indeed_url && (
                                                                    <a href={job.indeed_url} className="path-job__button" target="_blank">Search Jobs</a>
                                                                )
                                                            }
                                                        </div>
                                                    </>
                                                )

                                            }
                                        }
                                    })
                            }
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}

Footer.propTypes = {
    isShowCollegeDegree: PropTypes.bool.isRequired,
    getTracedJobs: PropTypes.func.isRequired,
    jobs: PropTypes.array.isRequired,
    levels: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    isMixpanel: PropTypes.bool.isRequired,
}
